import { DateConverter } from '@shared/entities/converters/date-converter';
import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('Maintenance')
export class Maintenance extends Entity {
  @JsonProperty('lastMaintenance', DateConverter)
  public lastMaintenance?: Date = undefined;
  @JsonProperty('nextMaintenance', DateConverter)
  public nextMaintenance?: Date = undefined;
  @JsonProperty('installDate', DateConverter)
  public installDate?: Date = undefined;
  @JsonProperty('remainingInterventions', Number)
  public remainingInterventions?: number = undefined;
}

